import { onMounted, onUnmounted } from 'vue'
import { useUserStore } from '@provise/stores/user'

export function useInactivityTracker(callback) {
  const userStore = useUserStore()
  const events = ['mousemove', 'keydown', 'scroll', 'click']

  const reset = () => {
    userStore.resetTimer(callback)
  }

  const start = () => {
    events.forEach(e => window.addEventListener(e, reset))
    window.addEventListener('storage', syncAcrossTabs)
    reset()
  }

  const stop = () => {
    events.forEach(e => window.removeEventListener(e, reset))
    window.removeEventListener('storage', syncAcrossTabs)
    userStore.stopLogoutChecker()
  }

  const syncAcrossTabs = e => {
    if (e.key === 'lastActivity') {
      userStore.startLogoutChecker(callback)
    }
  }

  onMounted(start)
  onUnmounted(stop)
}
